module.exports = __webpack_public_path__ + "static/media/car2.dd042d39.jpg";